import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/time/logs` (bare path) — TT-V11 Phase 1 (T00): the flat tab shell (`TimeLogsPage`) this path
 * used to render is retired, superseded by per-destination routes. Redirects to `/time/my-time`,
 * the closest surviving equivalent (today's `tracker` tab). `/time/logs/$timesheetId` is unaffected
 * — this redirect only fires on the bare `/time/logs` path, not its children.
 *
 * `replace: true` so the browser back button does not land on a URL that immediately bounces
 * forward again — same reasoning as the `/time` -> `/time/logs` redirect this one replaces.
 */
export const Route = createFileRoute('/time/logs/')({
  beforeLoad: () => {
    throw redirect({ to: '/time/my-time', replace: true });
  },
});
